import styled, { css } from 'styled-components'

const breakpoints = {
	mobile: '768px',
	tablet: '1024px',
	desktop: '1280px'
}

export const Container = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.brand.white});
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.mobile}) {
    display: none; 
  }
`

export const Header = styled.header`
	background-color: white;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: sticky;
	top: 0;
	z-index: 10;
`

export const HeaderButton = styled.button`
	padding: 0.5rem;
	margin-left: -0.5rem;
	background-color: transparent;
	border: none;
	border-radius: 0.5rem;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background-color: ${props => props.theme.colors.greys.dividerGray};
	}
`

export const Main = styled.div`
	padding: ${({ padding }) => padding || "24px 16px"};
	margin: 0 auto;
	width: 100%;
	display:flex;
	flex-direction: column;
	flex:1;
	`


export const PageTitle = styled.h2`
	font-size: 24px;
	font-weight: bold;
	color: ${props => props.theme.colors.text.primaryText};
	margin-bottom: 24px;

	${props =>
		props.align &&
		css`
			text-align: ${props.align};
		`}
`

export const OptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;

	${props =>
		props.gap &&
		css`
			gap: ${props.gap}rem;
		`}
`

export const OptionCard = styled.button`
	width: 100%;
	background-color: white;
	border-radius: 0.75rem;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
	border: 1px solid #e5e7eb;
	cursor: pointer;
	transition: all 0.2s;
	text-align: left;

	&:hover {
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
	}

	${props =>
		props.disabled &&
		css`
			opacity: 0.5;
			cursor: not-allowed;

			&:hover {
				box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
			}
		`}
`

export const OptionContent = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
`

export const IconWrapper = styled.div`
	width: 2.5rem;
	height: 2.5rem;
	background-color: ${props => props.bgColor || props.theme.colors.greys.dividerGray};
	border-radius: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: center;

	${props =>
		props.size &&
		css`
			width: ${props.size}rem;
			height: ${props.size}rem;
		`}
`

export const OptionText = styled.span`
	color: ${props => props.theme.colors.text.primaryText};
	font-weight: 500;

	${props =>
		props.secondary &&
		css`
			color: #6b7280;
			font-weight: 400;
			font-size: 0.875rem;
		`}
`

export const BottomNav = styled.nav`
	background-color: white;
	border-top: 1px solid #e5e7eb;
	padding: 0.5rem 1rem;
	position: sticky;
	bottom: 0;
`

export const BottomNavContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	max-width: 600px;
	margin: 0 auto;
`

export const NavButton = styled.button`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.25rem;
	padding: 8px 16px;
	background-color: transparent;
	border: none;
	border-radius: 0.5rem;
	cursor: pointer;
	color: ${props => (props.active ? '#0d9488' : '#6b7280')};
	position: relative;
	transition: color 0.2s;

	${props =>
		props.active &&
		css`
			&::after {
				content: '';
				position: absolute;
				bottom: -0.5rem;
				left: 50%;
				transform: translateX(-50%);
				width: 4rem;
				height: 0.25rem;
				background-color: #0d9488;
				border-radius: 9999px;
			}
		`}

	&:hover {
		color: #0d9488;
	}
`



export const Spacer = styled.div`
	width: ${props => props.width || '2.5'}rem;
	height: ${props => props.height || '1'}rem;
`

export const Text = styled.p`
	color: ${props => props.color || '#6b7280'};
	margin-bottom: ${props => props.mb || '1'}rem;
	font-size: ${props => props.size || '1'}rem;

	${props =>
		props.bold &&
		css`
			font-weight: bold;
		`}
`

export const Divider = styled.div`
	height: 1px;
	background-color: #e5e7eb;
	margin: ${props => props.margin || '1rem'} 0;
`

export const Card = styled.div`
	background-color: white;
	border-radius: 0.75rem;
	padding: ${props => props.padding || '1rem'};
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
	border: 1px solid #e5e7eb;

	${props =>
		props.noPadding &&
		css`
			padding: 0;
		`}
`

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(${props => props.columns || 2}, 1fr);
	gap: ${props => props.gap || '1'}rem;
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`

export const Flex = styled.div`
	display: flex;
	align-items: ${props => props.align || 'center'};
	justify-content: ${props => props.justify || 'flex-start'};
	gap: ${props => props.gap || '0.5'}rem;
	flex-direction: ${props => props.direction || 'row'};

	${props =>
		props.wrap &&
		css`
			flex-wrap: wrap;
		`}
`

export const Button = styled.button`
	background-color: ${props => (props.variant === 'primary' ? '#0d9488' : 'white')};
	color: ${props => (props.variant === 'primary' ? 'white' : '${props => props.theme.colors.text.primaryText}')};
	border: 1px solid ${props => (props.variant === 'primary' ? '#0d9488' : '#e5e7eb')};
	padding: 0.75rem 24px;
	border-radius: 0.5rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background-color: ${props => (props.variant === 'primary' ? '#0f766e' : '#f9fafb')};
	}

	${props =>
		props.fullWidth &&
		css`
			width: 100%;
		`}

	${props =>
		props.disabled &&
		css`
			opacity: 0.5;
			cursor: not-allowed;

			&:hover {
				background-color: ${props => (props.variant === 'primary' ? '#0d9488' : 'white')};
			}
		`}
`
